import moment from "moment";
import {isNullOrEmpty} from "./Utils";

// Format a string as a moment date using given dateFormat
export const formatValueAsDateAndTime = (dateValue:string, dateFormat = "M/D/YY hh:mm a") => {
    if (isNullOrEmpty(dateValue)) {
        return null;
    }

    return moment(dateValue).format(dateFormat).toUpperCase();
}

export const formatValueAsDate = (dateValue:string, dateFormat = "MM/DD/YYYY") => {
    if (isNullOrEmpty(dateValue)) {
        return null;
    }

    return moment(dateValue).format(dateFormat).toUpperCase();
}

export const formatIsoDateString = (value: string ,dateFormat = "MM/DD/YYYY") => {
    if (!value || typeof value !== 'string') return undefined;
    if (value?.endsWith("T00:00:00.000+00:00")) {
        const dateOnly = value?.split("T")[0]; // "2023-08-07"
        const [year, month, day] = dateOnly.split("-");
        return dateFormat
            ? moment(dateOnly).format(dateFormat)
            : `${month}/${day}/${year}`;
    }

    return moment(value).format(dateFormat);
};


